import app from '@/app';
import templateUrl from './parameterEvolution-search.html';

/* @ngInject */
function ParameterEvolutionSearchController($controller, $state, ParameterEvolution, Principal, AlertService) {
	var $ctrl = this;

	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	var transition = $ctrl.transition;

	$ctrl.transition = params => {
		transition(params);
		$ctrl.road = $ctrl.allRoads.content.find(it => it.id == params.road) || null;
		$ctrl.campaign = $ctrl.allCampaigns.content.find(it => it.id == params.campaign) || null;
		ParameterEvolution.query(
			{
				organizationId: params.organization,
				roadId: params.road,
				sort: params.sort,
				page: params.page,
				size: params.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	$ctrl.onOrganizationChange = () => {
		$ctrl.road = null;
		$ctrl.campaign = null;
	};

	$ctrl.onRoadTypeChange = () => {
		$ctrl.road = null;
		$ctrl.campaign = null;
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value =>
		$ctrl.organization && value.owner && value.owner.id == $ctrl.organization.id;

	$ctrl.onQueryChange = () => {
		var pOrganization = $ctrl.organization && $ctrl.organization.id ? $ctrl.organization.id : null;
		var pRoad = $ctrl.road && $ctrl.road.id ? $ctrl.road.id : null;

		ParameterEvolution.query(
			{
				organizationId: pOrganization,
				roadId: pRoad,
				sort: $ctrl.sort,
				page: 0,
				size: $ctrl.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	$ctrl.remove = id => {
		var entity = $ctrl.entities.find(e => e.id === id);
		ParameterEvolution.remove({ id: id }, () => {
			AlertService.success('entity.delete.message', {
				type: 'parameterEvolution',
				name: entity ? entity.name : ''
			});
			$state.reload();
		});
	};
}

app.component('parameterEvolutionSearch', {
	templateUrl,
	controller: ParameterEvolutionSearchController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<'
	}
});
